import i18n from 'simple-react-i18n'
import React from 'react'
import { hasValue } from '../../../../../utils/NumberUtil'
import { StyledFieldSet, StyledLegend, StyledSpan } from '../../../../../components/StyledElements'
import Input from '../../../../../components/forms/Input'
import StationImportCodeMessage from '../../../../../import/components/utils/StationImportCodeMessage'
import Select from '../../../../../components/forms/Select'
import IntegrationModeDialog from 'import/components/content/IntegrationModeDialog'
import { Grid } from '@mui/material'

const measureOptions = () => [
    {
        value: '',
        label: i18n.noDataIntegration,
    },
    {
        value: 'DATA_ADD_NEW_DATA',
        label: i18n.lastDataIntegration,
    },
    {
        value: 'DATA_REPLACE_HISTO',
        label: i18n.fullDataIntegration,
    },
]

const handleChangeDataIntegration = (integration, jobDataTypes, setJobDataTypes) => {
    const dataTypes = jobDataTypes.filter(d => !d.includes('DATA'))
    if (integration) {
        dataTypes.push(integration)
    }
    setJobDataTypes(dataTypes)
}

const getDataTypes = (type, jobDataTypes) => {
    if (jobDataTypes && jobDataTypes.length) {
        return jobDataTypes.find(d => d.includes(type)) || ''
    }
    return ''
}


const AddQualitoStepOptionsNaiades = ({
    station,
    changeStation,
    filters,
    changeFilters,
    jobDataTypes,
    setJobDataTypes,
}) => {
    return (
        <StyledFieldSet>
            <StyledLegend>
                <StyledSpan>{i18n.options}</StyledSpan>
            </StyledLegend>
            <div>
                <Grid container spacing={1} sx={{ paddingTop: 2 }}>
                    <Grid size={3}>
                        <Input value={station.code} onChange={v => changeStation({ code: v })} title={i18n.code} noSpace/>
                    </Grid>
                    <Grid size={5}>
                        <Select options={ measureOptions() } obligatory={true} label={ i18n.dataIntegration } value={ getDataTypes('DATA', jobDataTypes) } labelSpan={ <IntegrationModeDialog /> }
                            onChange={ v => handleChangeDataIntegration(v, jobDataTypes, setJobDataTypes) }
                        />
                    </Grid>
                    <Grid size={4} />
                </Grid>
                <Grid container sx={{ paddingTop: 2 }}>
                    <Grid size={12} sx={{ display: 'flex', alignItems: 'center' }}>
                        { hasValue(station.code) && <StationImportCodeMessage code={station.code} stationType='quality'/> }
                    </Grid>
                </Grid>
            </div>
        </StyledFieldSet>
    )
}

AddQualitoStepOptionsNaiades.propTypes = {
}

export default AddQualitoStepOptionsNaiades